// 환경변수 검증 및 기본값 설정
const validateEnv = () => {
  const env = {
    VITE_API_URL: import.meta.env.VITE_API_URL || "http://localhost:9003/api",
    NODE_ENV: import.meta.env.NODE_ENV,
    MODE: import.meta.env.MODE,
    SHOW_LOCAL_ICON: import.meta.env.VITE_SHOW_LOCAL_ICON === "true",
  };

  // 전역 환경변수 객체 생성
  const appEnv = {
    API_URL: env.VITE_API_URL,
    NODE_ENV: env.NODE_ENV || "development",
    MODE: env.MODE || "development",
    IS_DEV: env.NODE_ENV === "development",
    IS_PROD: env.NODE_ENV === "production",
    SHOW_LOCAL_ICON: env.SHOW_LOCAL_ICON || window.location.hostname === "localhost",
  };

  return appEnv;
};

// 환경변수 초기화
export const AppEnv = validateEnv();

// 환경변수 확인 함수
export const debugEnv = () => {
  console.log("🔍 [ENV] 환경변수 디버깅:", {
    raw: import.meta.env,
    processed: AppEnv,
  });
};

export default AppEnv;
